// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { init as initProtection } from './utils/protection';
import { I18nProvider } from './i18n';

initProtection();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><I18nProvider><App /></I18nProvider></React.StrictMode>);
